module.exports = __webpack_public_path__ + "img/DECHubUserPrivacyAgreementZH.1777b062.jpg";